export const MILESTONE_PATH_OPEN_EVENT = 'openMilestonePath';

export function openMilestonePathModal(milestoneId) {
  if (!milestoneId) return;
  window.dispatchEvent(
    new CustomEvent(MILESTONE_PATH_OPEN_EVENT, { detail: { milestoneId } }),
  );
}
